import script from "./SignIn.vue?vue&type=script&setup=true&lang=js"
export * from "./SignIn.vue?vue&type=script&setup=true&lang=js"

import "./SignIn.vue?vue&type=style&index=0&id=4ca8d65c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ca8d65c"]])

export default __exports__